












import Dashboard from './Dashboard';

export default {
  name: 'DashboardPage',
  components: {
    Dashboard,
  },
  props: {
    dashboardId: {
      type: String,
      required: true,
    },
  },
};
